// Modules
import React from "react";
import PropTypes from "prop-types";

const ExpandIcon = (props) => {
	const {
		clssName,
		color,
	} = props;

	return (
		<svg
			width="30"
			height="18"
			viewBox="0 0 30 18"
			className={clssName}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15.8198 16.7577L29.6597 2.88269C30.1108 2.42566 30.1108 1.69324 29.6597 1.23621C29.2026 0.785034 28.4702 0.785034 28.0132 1.23621L14.9995 14.2909L1.98582 1.24206C1.53465 0.785033 0.796366 0.785033 0.339334 1.24206C0.110817 1.47058 -0.0005093 1.76941 -0.000509313 2.06824C-0.000509326 2.36706 0.110817 2.66003 0.339334 2.88855L14.1792 16.7635C14.396 16.9803 14.6948 17.1034 14.9995 17.1034C15.3042 17.1034 15.603 16.9803 15.8198 16.7577Z"
				fill={color}
			/>
		</svg>
	);
};

ExpandIcon.propTypes = {
	clssName: PropTypes.string,
	color: PropTypes.string,
};

ExpandIcon.defaultProps = {
	clssName: "",
	color: "#0A313E",
};

export default ExpandIcon;